export const SET_ERRORS = 'SET_ERRORS'
export const SET_NOTIFICATION = 'SET_NOTIFICATION'
